export * from './ratings.component';